import { useFormContext } from 'react-hook-form';

export const useGetCoachingSessionIds = () => {
  const { getValues } = useFormContext();
  const [sessionId] = getValues(['coachingSessionId']);

  return {
    currentSessionId: sessionId,
    nextSessionId: getValues(`nextSessionAppointment.coachingSessionId`),
  };
};
